export function formatWatts(w: number): string {
  if (Math.abs(w) >= 1000) return `${(w / 1000).toFixed(1)} kW`
  return `${Math.round(w)} W`
}

export function formatTimeAgo(ts: string): string {
  const diff = Date.now() - new Date(ts).getTime()
  const seconds = Math.floor(diff / 1000)
  if (seconds < 60) return `${seconds}s ago`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

export function socColor(pct: number): string {
  if (pct >= 60) return 'text-status-online'
  if (pct >= 30) return 'text-severity-warning'
  return 'text-severity-critical'
}

export function formatCurrency(n: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(n)
}

export function formatNumber(n: number): string {
  return new Intl.NumberFormat('en-US').format(n)
}

export function cn(...classes: (string | boolean | undefined | null)[]): string {
  return classes.filter(Boolean).join(' ')
}

export function severityColor(severity: string): string {
  switch (severity) {
    case 'critical': return 'text-severity-critical'
    case 'warning': return 'text-severity-warning'
    case 'info': return 'text-severity-info'
    default: return 'text-text-secondary'
  }
}

export function severityBg(severity: string): string {
  switch (severity) {
    case 'critical': return 'bg-severity-critical/15 text-severity-critical'
    case 'warning': return 'bg-severity-warning/15 text-severity-warning'
    case 'info': return 'bg-severity-info/15 text-severity-info'
    default: return 'bg-bg-hover text-text-secondary'
  }
}

export function statusColor(status: string): string {
  switch (status) {
    case 'online': return 'bg-status-online'
    case 'offline': return 'bg-status-offline'
    case 'degraded': return 'bg-status-degraded'
    default: return 'bg-status-maintenance'
  }
}
